export default __webpack_public_path__ + "static/media/planningToBuy_active.0f2929bc.svg";